<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-clock :width="22" :height="22" />{{ names.title }}
      </v-col>
    </v-row>
    <!-- 시작시간 -->
    <v-row class="ma-0 bb-line">
      <v-col cols="12" class="py-5 px-6">
        <div class="borderLine-wrap" v-if="isAttend" style="color: #087ef7">
          <span class="borderLine-title">변경 전 출근시간</span>
          <span class="ml-auto">{{ GET_BEFORE_START_HM || '-' }}</span>
        </div>
        <div class="borderLine-wrap" @click="clickTimePicker('start')">
          <span class="borderLine-title">{{ names.startTime }}</span>
          <v-btn elevation="0" text fab width="24" height="24" class="ml-auto">
            <v-icon size="24" color="#9ca3ab">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div class="py-3">
          <span v-if="sHm !== ''">{{ sHm }}</span>
          <span v-else>{{ names.startTime }}이 입력됩니다.</span>
        </div>
      </v-col>
    </v-row>

    <!-- 종료시간 -->
    <v-row class="ma-0 bb-line">
      <v-col cols="12" class="py-5 px-6">
        <div class="borderLine-wrap" v-if="isAttend" style="color: #087ef7">
          <span class="borderLine-title">변경 전 퇴근시간</span>
          <span class="ml-auto">{{ GET_BEFORE_END_HM || '-' }}</span>
        </div>
        <div class="borderLine-wrap" @click="clickTimePicker('end')">
          <span class="borderLine-title">{{ names.endTime }}</span>
          <v-btn elevation="0" text fab width="24" height="24" class="ml-auto">
            <v-icon size="24" color="#9ca3ab">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div class="py-3">
          <span v-if="eHm !== ''">{{ eHm }}</span>
          <span v-else>{{ names.endTime }}이 입력됩니다.</span>
        </div>
      </v-col>
    </v-row>

    <!-- 다음버튼 -->
    <next-btn @next="nextStep()" />

    <!---------------------------------------------------------------------------->
    <!-- 시작 시간 선택 -->
    <bottom-time-picker :flag="sTimePickerFlag" @changeTime="setSTime" />
    <bottom-time-picker :flag="eTimePickerFlag" @changeTime="setETime" />
  </div>
</template>

<script>
import IconClock from '@/assets/customIcon/IconClock.vue';
import NextBtn from '@/components/application/buttons/AppNextBtn.vue';
import BottomTimePicker from '@/components/application/form/BottomTimePicker.vue';
import applCdMixin from '@/mixins/applCdMixin.js';
import { mapGetters, mapMutations } from 'vuex';
import routerNames from '@/const/routerConstants';

export default {
  mixins: [applCdMixin],
  data: () => ({
    sTimePickerFlag: false,
    eTimePickerFlag: false,
    sHm: '',
    eHm: '',
  }),

  computed: {
    ...mapGetters('ELA', ['GET_BEFORE_START_HM', 'GET_BEFORE_END_HM']),
    names() {
      if (this.isAttend) {
        // 출퇴근
        return {
          title: '시간을 변경해주세요',
          startTime: '변경할 출근시간',
          endTime: '변경할 퇴근시간',
        };
      } else if (this.isOtWork) {
        // 연장근무
        return {
          title: '연장근무 시간을 선택해주세요',
          startTime: '출근시간',
          endTime: '출근시간',
        };
      } else {
        // 근태
        return {
          title: '시간을 선택해주세요',
          startTime: '시작시간',
          endTime: '종료시간',
        };
      }
    },
  },
  methods: {
    ...mapMutations('ELA', ['SET_REQ_S_HM', 'SET_REQ_E_HM']),
    async nextStep() {
      if (!this.sHm || !this.eHm) {
        alert('시간을 선택해주세요');
        return false;
      }

      this.SET_REQ_S_HM(this.sHm.replaceAll(':', ''));
      this.SET_REQ_E_HM(this.eHm.replaceAll(':', ''));
      if (!this.isAttend) await this.$store.dispatch('ELA/FETCH_HOUR');

      this.$router.push(routerNames.ExtraOptions); // 추가옵션 화면
    },
    setSTime(time) {
      this.sHm = time;
    },
    setETime(time) {
      this.eHm = time;
    },
    clickTimePicker(gubun) {
      if (gubun === 'start') this.sTimePickerFlag = !this.sTimePickerFlag;
      else this.eTimePickerFlag = !this.eTimePickerFlag;
    },
  },
  components: {
    IconClock,
    NextBtn,
    BottomTimePicker,
  },
};
</script>
<style>
/* _approval.scss 에 넣음 */
</style>
